import * as React from "react";
import { cn } from "./utils";

export const Label = React.forwardRef<
  HTMLLabelElement,
  React.LabelHTMLAttributes<HTMLLabelElement>
>(({ className, ...props }, ref) => (
  <label
    ref={ref}
    className={cn(
      "text-xs font-medium uppercase tracking-wide text-slate-400",
      className
    )}
    {...props}
  />
));
Label.displayName = "Label";
